<div
  class="header-upgrade-plan-dialog"
  [attr.data-loading]="loading"
  [class.has-sticky-actions]="!loading && !loadError"
>
  <div class="dialog-body">
    <header class="dialog-header">
      <img
        class="dialog-logo"
        src="assets/images/brand/timedoctor/logo-full.svg"
        [attr.alt]="'header.upgradePlanDialog.logoAlt' | translate"
        height="42"
      />
      <h2 class="dialog-title">{{ 'header.upgradePlanDialog.title' | translate }}</h2>
      <p class="dialog-subtitle">{{ 'header.upgradePlanDialog.subtitle' | translate }}</p>
    </header>

    <div class="plan-cards-skeleton" *ngIf="loading; else content" aria-busy="true">
      <div class="plan-card-skeleton" *ngFor="let _ of skeletonCards">
        <div class="skeleton-header">
          <span class="skeleton-item skeleton-title"></span>
          <span class="skeleton-item skeleton-badge"></span>
        </div>
        <span class="skeleton-item skeleton-description"></span>
        <span class="skeleton-item skeleton-price"></span>
        <span class="skeleton-item skeleton-feature" *ngFor="let __ of skeletonFeatures"></span>
      </div>
    </div>

    <ng-template #content>
      <div class="dialog-error" *ngIf="loadError; else plans">
        <p>{{ 'header.upgradePlanDialog.loadError' | translate }}</p>
        <button
          mat-stroked-button
          type="button"
          (click)="onCancel()"
          [ampTrack]="'action-button'"
          [ampTrackDetail]="'upgrade-error-cancel'"
        >
          {{ 'common.cancel' | translate | uppercase }}
        </button>
      </div>

      <ng-template #plans>
        <div class="plan-cards" role="listbox" [attr.aria-label]="'header.upgradePlanDialog.subtitle' | translate">
          <button
            type="button"
            class="plan-card-option"
            *ngFor="let card of upgradePlans"
            role="option"
            [attr.aria-selected]="isSelected(card.plan)"
            [class.selected]="isSelected(card.plan)"
            [class.recommended]="card.isPopular && isSelected(card.plan)"
            (click)="selectPlan(card.plan)"
            [ampTrack]="'plan-selector'"
            [ampTrackDetail]="ampTrackDetailFor(card.plan)"
          >
            <app-plan-card
              class="v2"
              [plan]="card.plan"
              [currentPlan]="currentPlan"
              [showPopularBadge]="!!card.isPopular && isSelected(card.plan)"
              [useRecommendedBadge]="true"
              [payRecurrence]="payRecurrence"
              [isV2]="true"
              [simpleRecurrenceLabel]="false"
              [hideActionButtons]="true"
              [hideAllPlanFeaturesPrefix]="true"
              [hidePopularIcon]="true"
              [hideBilledRecurrenceDescription]="true"
              [hideStatusBadge]="true"
              [featuresOverride]="featureKeysFor(card.plan)"
            ></app-plan-card>
          </button>
        </div>
      </ng-template>
    </ng-template>
  </div>

  <footer class="dialog-actions" *ngIf="!loading && !loadError">
    <button
      mat-stroked-button
      type="button"
      class="cancel-btn"
      (click)="onCancel()"
      [disabled]="continuing"
      [ampTrack]="'action-button'"
      [ampTrackDetail]="'upgrade-cancel'"
    >
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      class="continue-btn"
      (click)="onContinue()"
      [disabled]="!selectedPlan || continuing"
      [ampTrack]="'action-button'"
      [ampTrackDetail]="'upgrade-continue'"
    >
      <mat-spinner *ngIf="continuing" diameter="20"></mat-spinner>
      <span [class.invisible]="continuing">{{ 'common.continue' | translate | uppercase }}</span>
    </button>
  </footer>
</div>
